import React from 'react';
import { ReferralPartnerSelect } from '@/components/selects/ReferralPartnerSelect';
import { useObjectContext } from '@/hooks/useObjectContext';
import { useUpdateClientRowMutation } from '@/features/clients/clientsApi';

const ReferralPartnerField = ({ minimal = true }) => {
	const { clientRow, clientId } = useObjectContext();

	const [updateClientRow, { isLoading }] = useUpdateClientRowMutation();

	const handleChange = async (value) => {
		await updateClientRow({
			clientId,
			docId: clientRow?.docId,
			properties: {
				referralPartner: value || null,
			},
		}).unwrap();
	};

	return (
		<ReferralPartnerSelect
			value={clientRow?.referralPartner ?? ''}
			disabled={isLoading}
			onChange={handleChange}
			minimal={minimal}
		/>
	);
};

export default ReferralPartnerField;
